import React, { useRef, useState } from "react";
import ExpandablePanelBody from "./ExpandablePanelBody";
import ExpandablePanelHeader from "./ExpandablePanelHeader";

const ExpandablePanel = (props) => {
  const [expanded, setExpanded] = useState(true);
  const parentRef = useRef();

  return (
    <div className={`bg-white rounded-md ${props.className}`} ref={parentRef} >
      {React.Children.map(props.children, (child) => {
        return React.cloneElement(child, {
          expanded: expanded,
          setExpanded: setExpanded,
          parentRef: parentRef,
        });
      })}
    </div>
  );
};

ExpandablePanel.Body = ExpandablePanelBody;
ExpandablePanel.Header = ExpandablePanelHeader;

export default ExpandablePanel;
